export type Dictionary<T> = {
  [key: string]: T;
};

export const partition = <T>(
  arr: T[],
  partitionFn: (e: T) => boolean
): T[][] => {
  return [arr.filter(partitionFn), arr.filter((e) => !partitionFn(e))];

  //leave here for knowledge, reduce is exponentially expensive than filter x2
  /*
  return arr.reduce(
    ([matched, unmatched]: T[][], e: T) => {
      return partitionFn(e)
        ? [[...matched, e], unmatched]
        : [matched, [...unmatched, e]];
    },
    [[], []]
  );
  */
};

export const sumArr = (arr: number[]) => {
  let count = 0;
  for (let j = 0; j < arr.length; ++j) {
    count += arr[j];
  }
  return count;
};

export const sumArrByKey = <T extends any>(arr: T[], key: keyof T) => {
  let count = 0;
  for (let j = 0; j < arr.length; ++j) {
    count += arr[j][key] as number;
  }
  return count;
};

export const isNotUndefined = <T extends any>(e: T | undefined): e is T => {
  return e !== undefined;
};

export const isUndefined = <T extends any>(
  e: T | undefined
): e is undefined => {
  return e === undefined;
};

export const getRandomFromArr = <T>(arr: T[]): T => {
  return arr[Math.floor(arr.length * Math.random())];
};
